import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-4 md:p-6 transition-base hover:shadow-md">
      <div className="flex items-start space-x-4 mb-4">
        <div className="flex-shrink-0">
          <Image
            src={testimonial?.profileImage}
            alt={testimonial?.name}
            className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h5 className="text-base md:text-lg font-heading font-bold text-foreground">
            {testimonial?.name}
          </h5>

          <p className="text-xs md:text-sm text-muted-foreground">
            {testimonial?.role}
          </p>

          <div className="flex items-center space-x-1 mt-2">
            {[...Array(5)].map((_, i) => (
              <Icon
                key={i}
                name="Star"
                size={16}
                color={
                  i < testimonial?.rating
                    ? "var(--color-accent)"
                    : "var(--color-muted-foreground)"
                }
                className={i < testimonial?.rating ? "fill-current" : ""}
              />
            ))}
          </div>
        </div>
      </div>

      <p className="text-sm md:text-base text-foreground leading-relaxed">
        “{testimonial?.testimonialText}”
      </p>
    </div>
  );
};

export default TestimonialCard;
